import { Button, Text } from '@chakra-ui/react';
import { ShowFragmentFragment } from 'src/generated/graphql';
import colors from 'src/theme/colors';
import { useMyShowsContext } from './MyShowsContext';

type Props = {
  showId: ShowFragmentFragment['id'];
  showExpiresAt: string;
};

export default function RenewShowButton({ showId, showExpiresAt }: Props) {
  const { setContentType, setShowToRenew, onOpen, isMyAccount } = useMyShowsContext();

  function getDaysRemaining() {
    // GraphQL's String scalar serializes Date fields via valueOf().toString(),
    // so showExpiresAt arrives as a ms-since-epoch string. Try Date.parse first
    // for ISO/UTC strings, fall back to parseInt for the ms-string case.
    const expiresMs = Date.parse(showExpiresAt) || parseInt(showExpiresAt, 10);
    if (!Number.isFinite(expiresMs)) return 0;
    const daysRemaining = Math.ceil((expiresMs - Date.now()) / (1000 * 60 * 60 * 24)) - 1;
    return Math.max(daysRemaining, 0);
  }

  return (
    <>
      <Text
        as="span"
        color={colors.podcastShade500}
        fontSize="13px"
        mr="10px"
      >{`${getDaysRemaining()} days remaining`}</Text>
      <Button
        visual="quaternary"
        bg={colors.podcastLightBlue100}
        color={colors.podcastBlue700}
        mr="10px"
        _hover={{
          bg: colors.podcastLightBlue100,
          opacity: 0.7,
          _disabled: {
            bg: colors.podcastLightBlue100,
            opacity: 0.5,
          },
        }}
        onClick={() => {
          setContentType('renew-show');
          setShowToRenew(showId);
          if (isMyAccount) {
            onOpen();
          }
        }}
      >
        Renew
      </Button>
    </>
  );
}
